module.exports = "/assets/logo_with_text-445c0f56fd1f13792c6f2596abae3449.svg";